export interface WidgetCompanyAlertsBreakdownDTO {
  activeAlertBars            : number | null;
  activeAlertLimitIncreases  : number | null;
  activeAlertProductChanges  : number | null;
  activeAlertThrottles       : number | null;
  activeDataUsageAlerts      : number | null;
  activePercentageLimitAlerts: number | null;
  activeSpendLimitAlerts     : number | null;
};

export function WidgetCompanyAlertsBreakdownDTO_EmptyObject(): WidgetCompanyAlertsBreakdownDTO {
  return {
    activeAlertBars            : null,
    activeAlertLimitIncreases  : null,
    activeAlertProductChanges  : null,
    activeAlertThrottles       : null,
    activeDataUsageAlerts      : null,
    activePercentageLimitAlerts: null,
    activeSpendLimitAlerts     : null
  };
};
